import React, { useState, useRef } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import API_CALLS from 'API_CALLS/index';
import FormBuilder from 'global/components/FormBuilder/index';
import LayoutBuilder from 'LayoutBuilder';

const {Container, Row, Column} = LayoutBuilder;


/*
SEE admin/index


<TemplateDBEdit
  ref={e=>this.TemplateDBNewRef=e}
  ID={"ID"}
  FIELD={"user"} //PATH INSIDE DATA WHERE THE CURRENT OBJ IS
  INCLUDE={[ //OPTIONAL
    {
      name: "user"
    }
  ]}
  NAME={"name"}
  isValidChange={(newValue)=>{}}
/>



<button 
  style={{"maxWidth":"250px","width":"100%","fontWeight":"700","textTransform":"uppercase"}} 
  className="button button1" 
  onClick={()=>{
    window.GlobalUtil.triggerEvent("TemplateDBEvent", {
      NAME: "USERS",
      TITLE: "User",
      TYPE: "EDIT",
      ID: "",
      FIELD: "NEW", //PATH INSIDE DATA WHERE THE CURRENT OBJ IS
      INCLUDE: [ //OPTIONAL
        {
          name: "user"
        }
      ]
    });
  }}>
    <i className="fas fa-edit"></i>&nbsp;&nbsp;<span>Edit</span>
</button>
*/

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideForm: false,
      isValid: false
    };    
    this.APIGetCurrent = this.APIGetCurrent.bind(this);
    this.formBuilderZone = this.formBuilderZone.bind(this);
    this.onSave = this.onSave.bind(this);
    window.CurObj = {};
    window.APIGetAgain = this.APIGetCurrent;
  }
  componentDidMount(){
    this.APIGetCurrent();
  }
  componentWillUnmount(){
    //clearTimeout(this.timeoutListener);
  }

  APIGetCurrent(callBack=()=>{}){      
    var inputObj = {
      query: API_CALLS[this.props.NAME].QUERIES.single(),
      variables: {
        id: this.props.ID,
        include: this.props.INCLUDE
      },
      fetchPolicy: "no-cache"
    }
    window.Client.query(inputObj)
    .then((obj) => {
      var {data, loading} = obj;          
      //console.log(`data`,"\n\n",data,"\n\n");
      if(!this) return;
      //window.CurObj =
      window.CurObj = window.GlobalUtil.stripOutFromObj(data[this.props.FIELD], "__typename");
      window.CurObj.id = window.CurObj._id;
      //console.log("APIGetCurrent -> window.CurObj","\n\n",window.CurObj,"\n\n");
      this.setState({date: new Date(), hideForm: true}, ()=>{
        this.setState({hideForm: false})
      })
    })
    .catch((error)=>{
      console.log("query plan failed", error);
    });
  }



  formBuilderZone(FORM_FIELDS){
    var {hideForm, isValid} = this.state;
    return (
      <Container>
        <Row>
          <Column 
            className={""}>
            {
              (!hideForm && window.CurObj._id) && 
              <div >
                <Container className="">
                  <FormBuilder
                    disableKeySubmit={true}
                    initialValues={window.CurObj}
                    listOfFields={FORM_FIELDS(window.CurObj)}
                    onSubmit={()=>{
                    }}
                    onChange={newObj => {
                      window.CurObj = {...window.CurObj, ...newObj};
                      //TODO: ILL ADD A VALIDATION LATER
                      //console.log("window.CurObj","\n\n",window.CurObj,"\n\n");
                      // if(this.timeoutListener) clearTimeout(this.timeoutListener);
                      // this.timeoutListener = setTimeout(()=>{
                      //   this.validate(true)
                      //   clearTimeout(this.timeoutListener)
                      // }, 1000);   
                            
                    }}
                    onValidate={(isValid)=>{
                      this.setState({isValid});
                      if(this.props.isValidChange) this.props.isValidChange(isValid);
                    }}
                  />
                </Container>
              </div>
            }
          </Column>
        </Row>
      </Container>
    )
  }


  onSave(onSuccess=()=>{}, onFail=()=>{}, close=true){
    if(!this.state.isValid) return;
    var {NAME} = this.props;
    var curObjClean = window.GlobalUtil.APISubmitObjCleaner(API_CALLS[NAME].CLEAN_FIELDS, window.CurObj);
    if(API_CALLS[NAME].FINAL_MOD_EDIT) curObjClean = API_CALLS[NAME].FINAL_MOD_EDIT(curObjClean);
    //console.log("curObjClean","\n\n",curObjClean,"\n\n");          
    //newObj.completeTaskID = window.CurObj._id; //IF THIS EXSIT THEN IT WILL AUTO COMPLETE THIS TASK WHEN DONE
    // Object.keys(curObjClean).map((key, index)=>{
    //   if(!curObjClean[key]) delete curObjClean[key];
    //   if(Array.isArray(curObjClean[key]) && curObjClean[key].length < 1) delete curObjClean[key];
    // })    
    //delete curObjClean.meta;
    var inputObj = {
      mutation: API_CALLS[NAME].MUTATIONS.update(),
      variables: curObjClean
    }
    //console.log(`curObjClean`,"\n\n",curObjClean,"\n\n");
          
    //console.log(`inputObj`,"\n\n",inputObj,"\n\n");
    window.Client.mutate(inputObj)
    .then((obj) => {
      var {data, loading} = obj;
      if(close) onSuccess();
    })
    .catch((error)=>{
      console.log("APICreate Request TP failed catch", error);
      if(close){
        onFail();
      } 
      
    });
  }

  render(){
    var {NAME} = this.props;          
    if(!NAME) return null;
    return (
      <div className="">
        <br/>
        <br/>
        {this.formBuilderZone(API_CALLS[NAME].FORM_FIELDS)}
        <br/>
        <br/>
      </div>
    );
  }
}









export default Index;